<template>
    <v-list>
        <v-list-tile v-if="!numeroProtocoloOcorrencia" @click="navegarParaOcorrenciaEsfinge">
            <v-list-tile-title>
                <v-icon size="15" class="mr-2">mdi-file-alert</v-icon>
                Ocorrência - E-Sfinge
            </v-list-tile-title>
        </v-list-tile>

        <v-list-tile
            v-else
            v-for="acao in acoesFiltradas(acoesMenu)"
            :id="acao.id"
            :key="acao.id"
            dense
        >
            <v-icon v-if="acao.icon" :size="16" class="mr-2">{{ acao.icon }}</v-icon>

            <v-list-tile-content v-if="acao.subnivel && acao.subnivel.length > 0">
                <v-menu open-on-hover right offset-x>
                    <template #activator="{ on }">
                        <div class="d-flex justify-space-between acao-nome" v-on="on">
                            {{ acao.nome }}
                            <v-icon size="28">mdi-menu-right</v-icon>
                        </div>
                    </template>

                    <v-list>
                        <v-list-tile
                            v-for="acaoSubnivel in acoesFiltradas(acao.subnivel)"
                            :id="acaoSubnivel.id"
                            :key="acaoSubnivel.id"
                            dense
                            @click="executarAcao(acaoSubnivel.evento)"
                        >
                            <v-icon v-if="acaoSubnivel.icon" :size="20" class="mr-2">{{ acaoSubnivel.icon }}</v-icon>
                            <v-list-tile-content class="acao-subnivel-nome"> {{ acaoSubnivel.nome }} </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-list-tile-content>
        </v-list-tile>
    </v-list>
</template>


<script>
export default {
    name: 'AcoesEnviosOcorrencia',
    props:['numeroProtocoloOcorrencia'],
    data() {
        return {
            acoesMenu: [
                {
                    id: 1,
                    nome: 'Ocorrência - E-Sfinge',
                    icon: 'mdi-file-alert',
                    subnivel: [
                        { id: 2, nome: 'Enviar', evento: 'navegarParaOcorrenciaEsfinge' },
                        { id: 3, nome: 'Ver Protocolos', evento: 'navegarParaProtocoloOcorrencia' }
                    ]
                },
            ]
        }
    },
    methods: {
        navegarParaOcorrenciaEsfinge() {
            const id = this.$route.params.id
            this.$router.push({ name: 'OcorrenciaEsfinge', params: { id } })
        },
        navegarParaProtocoloOcorrencia() {
            const compraDiretaId = this.$route.params.id
            this.$router.push({ name: 'ProtocoloOcorrencia', params: { compraDiretaId } })
        },
        executarAcao(evento){
            if(evento === 'navegarParaOcorrenciaEsfinge'){
                this.navegarParaOcorrenciaEsfinge()
            } else if(evento === 'navegarParaProtocoloOcorrencia'){
                this.navegarParaProtocoloOcorrencia()
            } else {
                this.$emit(evento)
            }
        },
        acoesFiltradas(acoes) {
            return acoes
        }
    }
}
</script>

<style scoped lang="stylus">
    .acao-nome
        margin-left: 2px
        font-size: 14px
        line-height: 26px
    .acao-subnivel-nome
        font-size: 14px
</style>

